import { create } from 'zustand';

interface DashboardState {
  selectedProfile: string | null;
  setSelectedProfile: (profile: string | null) => void;
  selectedVendor: string | null;
  setSelectedVendor: (vendor: string | null) => void;
  selectedVersion: string | null;
  setSelectedVersion: (version: string | null) => void;
  selectedPortfolio: string | null;
  setSelectedPortfolio: (portfolio: string | null) => void;
  refreshKey: number;
  triggerRefresh: () => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  selectedProfile: null,
  setSelectedProfile: (profile) => set({ selectedProfile: profile }),
  selectedVendor: null,
  setSelectedVendor: (vendor) => set({ selectedVendor: vendor }),
  selectedVersion: null,
  setSelectedVersion: (version) => set({ selectedVersion: version }),
  selectedPortfolio: null,
  setSelectedPortfolio: (portfolio) => set({ selectedPortfolio: portfolio }),
  refreshKey: 0,
  triggerRefresh: () => set((s) => ({ refreshKey: s.refreshKey + 1 })),
}));
